// Lightweight user-agent parsing — no external dependency
export interface ParsedUA {
  device_type: 'mobile' | 'tablet' | 'desktop';
  browser: string;
  os: string;
}

export const parseUserAgent = (ua: string): ParsedUA => {
  const u = ua.toLowerCase();

  // Device
  let device_type: ParsedUA['device_type'] = 'desktop';
  if (/ipad|tablet|playbook|silk|(android(?!.*mobile))/i.test(ua)) device_type = 'tablet';
  else if (/mobile|iphone|ipod|android.*mobile|blackberry|webos|opera mini/i.test(ua)) device_type = 'mobile';

  // Browser (order matters)
  let browser = 'Other';
  if (/edg\//i.test(ua)) browser = 'Edge';
  else if (/opr\/|opera/i.test(ua)) browser = 'Opera';
  else if (/chrome/i.test(ua) && !/chromium/i.test(ua)) browser = 'Chrome';
  else if (/firefox|fxios/i.test(ua)) browser = 'Firefox';
  else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = 'Safari';

  // OS
  let os = 'Other';
  if (/windows nt/i.test(ua)) os = 'Windows';
  else if (/iphone|ipad|ipod/i.test(ua)) os = 'iOS';
  else if (/android/i.test(ua)) os = 'Android';
  else if (/mac os x|macintosh/i.test(ua)) os = 'macOS';
  else if (/linux/i.test(ua)) os = 'Linux';

  return { device_type, browser, os };
};

export const getReferrerSource = (referrer: string | null | undefined): string => {
  if (!referrer) return 'Přímé';
  try {
    const host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, '');
    if (host.includes('google')) return 'Google';
    if (host.includes('facebook') || host.includes('fb.com') || host.includes('fb.me')) return 'Facebook';
    if (host.includes('instagram')) return 'Instagram';
    if (host.includes('bing')) return 'Bing';
    if (host.includes('duckduckgo')) return 'DuckDuckGo';
    if (host.includes('youtube')) return 'YouTube';
    if (host.includes('tomartmask')) return 'Přímé';
    return host;
  } catch {
    return 'Ostatní';
  }
};
